/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

/* eslint-disable no-console */

import { Middleware } from 'redux';
import IFDebug from '../../core/configs/IFDebug';

export default function createLoggerMidleware(): Middleware {
  return (store) => (next) => (action) => {
    const log = IFDebug.LOG_REDUX_STATE_BLACK_LIST_REGEX
      ? !action.type.match(IFDebug.LOG_REDUX_STATE_BLACK_LIST_REGEX)
      : true;

    if (log) {
      console.group(action.type);
      console.info('dispatching', action);
    }
    const result = next(action);
    if (log) {
      console.log('next state', store.getState());
      console.groupEnd();
    }
    return result;
  };
}
